var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "SetInvoiceVatPeriod",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: { name: "createOptions" },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "vat_period",
                        row: "",
                        "label-cols-md": "0",
                        "content-cols-md": "12",
                        required: "",
                        label: _vm._f("pgettext")(
                          "VAT Period",
                          "SetInvoiceVatPeriod"
                        )
                      }
                    },
                    [
                      _c("ItpFormSelect", {
                        attrs: {
                          name: "vat_period",
                          options: _vm.vatPeriods,
                          valueField: "id",
                          textField: "name",
                          required: ""
                        },
                        model: {
                          value: _vm.item.vat_period,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "vat_period", $$v)
                          },
                          expression: "item.vat_period"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "lock_invoices",
                        description: _vm._f("pgettext")(
                          "Lock invoices in order to prevent further modifications",
                          "SetInvoiceVatPeriod"
                        ),
                        row: "",
                        "label-cols-md": "0",
                        "content-cols-md": "12"
                      }
                    },
                    [
                      _c("ItpFormCheckbox", {
                        attrs: {
                          name: "lock_invoices",
                          label: _vm._f("pgettext")(
                            "Lock invoices",
                            "SetInvoiceVatPeriod"
                          )
                        },
                        model: {
                          value: _vm.item.lock_invoices,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "lock_invoices", $$v)
                          },
                          expression: "item.lock_invoices"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  form: _vm.forms.createOptions && _vm.forms.createOptions.id,
                  text: _vm._f("pgettext")("Submit", "SetInvoiceVatPeriod"),
                  type: "submit",
                  variant: "primary",
                  spinning: _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Cancel", "SetInvoiceVatPeriod"),
                  variant: "default",
                  disabled: _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }